/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerVehicleCategoryData
 */
export interface PartnerVehicleCategoryData {
    /**
     * 
     * @type {string}
     * @memberof PartnerVehicleCategoryData
     */
    vehicleCategory: PartnerVehicleCategoryDataVehicleCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PartnerVehicleCategoryData
     */
    buildSeries: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerVehicleCategoryData
     */
    isBookable: boolean;
    /**
     * 
     * @type {number}
     * @memberof PartnerVehicleCategoryData
     */
    minimumAge: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerVehicleCategoryData
     */
    meetsAgeRequirement: boolean;
}


/**
 * @export
 */
export const PartnerVehicleCategoryDataVehicleCategoryEnum = {
    M: 'M',
    L: 'L',
    XL: 'XL'
} as const;
export type PartnerVehicleCategoryDataVehicleCategoryEnum = typeof PartnerVehicleCategoryDataVehicleCategoryEnum[keyof typeof PartnerVehicleCategoryDataVehicleCategoryEnum];


/**
 * Check if a given object implements the PartnerVehicleCategoryData interface.
 */
export function instanceOfPartnerVehicleCategoryData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "vehicleCategory" in value;
    isInstance = isInstance && "buildSeries" in value;
    isInstance = isInstance && "isBookable" in value;
    isInstance = isInstance && "minimumAge" in value;
    isInstance = isInstance && "meetsAgeRequirement" in value;

    return isInstance;
}

export function PartnerVehicleCategoryDataFromJSON(json: any): PartnerVehicleCategoryData {
    return PartnerVehicleCategoryDataFromJSONTyped(json, false);
}

export function PartnerVehicleCategoryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerVehicleCategoryData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vehicleCategory': json['vehicleCategory'],
        'buildSeries': json['buildSeries'],
        'isBookable': json['isBookable'],
        'minimumAge': json['minimumAge'],
        'meetsAgeRequirement': json['meetsAgeRequirement'],
    };
}

export function PartnerVehicleCategoryDataToJSON(value?: PartnerVehicleCategoryData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vehicleCategory': value.vehicleCategory,
        'buildSeries': value.buildSeries,
        'isBookable': value.isBookable,
        'minimumAge': value.minimumAge,
        'meetsAgeRequirement': value.meetsAgeRequirement,
    };
}

